import StorageAuth from '@/store/modules/authComponents/storage'

const state = {status: '', profile: StorageAuth.getUserData()}

const getters = {
  getProfile: state => StorageAuth.getUserData(),
  isProfileLoaded: state => !!state.profile.id,
  regionUser: st => state.profile != null ? state.profile.region : 'ru'
}

const actions = {}

const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js